import { render, staticRenderFns } from "./WidgetList.vue?vue&type=template&id=83489bc0&scoped=true"
import script from "./WidgetList.vue?vue&type=script&lang=js"
export * from "./WidgetList.vue?vue&type=script&lang=js"
import style0 from "./WidgetList.vue?vue&type=style&index=0&id=83489bc0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83489bc0",
  null
  
)

export default component.exports